import React from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { Loader, LoadersContainer } from '@/app/components/search/components/Card/Loaders/styled.ts';

type CardLoaderProps = {
  isOverlay: boolean;
};

const CardDetailsLoader = ({ isOverlay }: CardLoaderProps) => {
  const { isMobile } = useCommonClient();

  if (isOverlay) {
    return (
      <LoadersContainer>
        <Loader elWidth={234} elHeight={40} style={{ marginTop: 4, marginBottom: isMobile ? 0 : 16 }} />
      </LoadersContainer>
    );
  }

  return (
    <LoadersContainer>
      <Loader elWidth={227} elHeight={38} style={{ marginTop: 4, marginBottom: 4 }} />
      <Loader elWidth={266} elHeight={20} style={{ marginBottom: 16 }} />
    </LoadersContainer>
  );
};

export default CardDetailsLoader;
